import React, { useState, useEffect } from "react";
import { UseFirstPageContent } from "./UseFirstPageContent";
import { Autocomplete, TextField } from "@mui/material";
import { readFromLS, writeToLS } from "../../util/LocalStrogeService";

export default function HomePageAutoCom(props) {
  const { AllHomePages } = UseFirstPageContent();
  const [homePageRes, setHomePageRes] = useState();
  const [selectedHomePage, setSelectedHomePage] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );

  useEffect(() => {
    AllHomePages((homePages) => {
      if (!selectedHomePage) {
        writeToLS("homePage", homePages[0]);
      }

      setHomePageRes(homePages);
    });
  }, [selectedHomePage]);

  useEffect(() => {
    if (selectedHomePage) {
      props.setter(selectedHomePage);
    }
  }, [selectedHomePage]);

  return homePageRes ? (
    <Autocomplete
      id="combo-box-demo"
      value={selectedHomePage ? selectedHomePage : homePageRes[0]}
      options={homePageRes ? homePageRes : []}
      getOptionLabel={(homePages) => (homePages.title ? homePages.title : "")}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField error={props.validation} {...params} label="صفحه نخست" />
      )}
      sx={{ width: "300px" }}
      onChange={(evt, newValue) => {
        if (newValue) {
          setSelectedHomePage(newValue);
        } else {
          setSelectedHomePage();
          props.setter(0);
        }
      }}
      size="small"
    />
  ) : (
    ""
  );
}
